import React from 'react';
import { motion } from 'framer-motion';
import { Building, Briefcase, Rocket, User } from 'lucide-react';
import { clientTypes } from '../data/mock';

const icons = [Building, Briefcase, Rocket, User];

const ClientsSection = () => {
  return (
    <section className="section" id="clients" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="caption mb-4 inline-block" style={{ color: 'var(--accent-primary)' }}>
            Our Clients
          </span>
          <h2 className="heading-1 mb-4">Who We Work With</h2>
          <p className="body-large max-w-2xl mx-auto">
            Our services are designed for both organizations and individuals.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {clientTypes.map((client, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={client.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center p-6 rounded-xl transition-all hover:bg-[var(--bg-card)]"
                style={{ border: '1px solid transparent' }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--border-primary)'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = 'transparent'}
              >
                <div className="icon-container mx-auto mb-4">
                  <Icon size={24} />
                </div>
                <h3 className="heading-3 mb-2">{client.title}</h3>
                <p className="body-small">
                  {client.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
